import { useContext } from 'react'

import { IconListContext } from './context'

export function useIconList() {
  return useContext(IconListContext)
}
